import React, { memo } from "react";
import { getSdk } from "../../services/sdkService";
import {
  CAROUSEL_TYPES,
  withFocusable,
  Loading,
  ModalSettings,
  Toast,
  Text
} from "../../services/visualLibraryService";
import { goToDetailPageByProgramType } from "../../utils/goToDetailPage";
import {
  LayoutStyled,
  ButtonStyled,
  ShadowLayoutStyled,
  LayoutEmptyStyled,
  HeroBanner,
  ContainerStyled,
  ImageBannerStyled,
  TextStyled,
  ContainerButtonStyled,
  ButtonModalStyled
} from "./styles/Styled";
import { TypedCarouselStyled } from "../../styles/shared-styles";
import { playHandler, play } from "../../utils/mediaDataRetrieval";
import { getLocaleFromLocalCache } from "../../services/localeCacheService";
import getBrands from "../../services/layoutService";
import { getSavedFocusInfo, removeSavedFocusInfo, saveFocusInfo } from "../../services/layoutService";
import getSportsAddons from "../../services/sportPackageService";
import {
  isUserSubscribedToChannel,
  isAddonContent,
  getBrandName,
  getBrandLogoUrl,
  isStarzPlaySubscription,
  isChampionsTrophyFlow
} from "../../utils/subscriptionUtils";
import getTitlesFormattedForCarousels from "../../utils/getTitlesFormattedForCarousels";
import { withAppState, getAppState } from "../../state";
import { i18n, directions } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getInternetConnectivityModalConfig } from "../../errors/utils";
import { getGlobalButtonFocusPath, getGlobalButtonInfo } from "../../errors/globalButtons";
import { CellMeasurer, CellMeasurerCache, List } from "react-virtualized";
import { defaultFocusPath as headerFocusPath } from "../../components/Header";
import { defaultFocusPath as mediaControlFocusPath } from "../../components/MediaControlsList";
import { config } from "../../config/config";
import throttle from "../../helpers/throttle";
import {
  trackPage,
  trackEvent,
  getLayoutEventLabel,
  trackEventPushData,
  trackEventInitializeData
} from "../../services/analyticsService";
import { resolution } from "../../config/ui/resolutionConfig";
import { routes } from "../../routes";
import { showNotLoggedModal, showExpiredContentModal } from "../../services/modalsService";
import {
  sameLayoutRequestIsInProgress,
  setLayoutRequestInProgress,
  unsetLayoutRequestInProgress
} from "./layoutNetworkUtils";
import { starzRevamp as Theme } from "starz-visual-themes";
import { sections } from "../../routes";
import { getPath } from "../../utils/getPath";
import * as Sentry from "@sentry/browser";
import { findFromBrands } from "../../helpers/find";
import { getNavigationReferences, redirectTo } from "../../services/navigationService";
import MediaControlsList from "../../components/MediaControlsList/MediaControlsList";
import getMediaItems from "../../components/MediaControlsList/mediaItems";
import { getCacheGeneratedImage } from "../../utils/staticCache";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";
import { ButtonStyled as ModalButtonStyled } from "../../components/ModalSettings/styles/Styled";
import {
  expiredContent,
  isTVODContent,
  isSVODContent,
  isTVODPriority,
  isContentActive,
  tvodTimeExpire,
  pramsYouborra,
  redirectToBuyBrandsPage,
  getBuyBrandsInfoObj,
  setCurrentStatusForPlayerObj,
  getBuyBrandsInfoObjChampionsTrophy,
  CHAMPIONS_TROPHY,
  CRICLIFE
} from "../../utils/tvodUtils";

const noHeader = url => url.search(/\/brands\/.*?(?=$|\/$)/) === 0;

const YEAR_CONST = 2018;
const starzplay = "starzplay";

const NO_HEADER_MARGIN_TOP_IN_PX = 196; // 10.2rem top margin if no hero carousel

const MediaControlsListFocus = withFocusable(MediaControlsList);
const ButtonBannerFocus = withFocusable(ButtonModalStyled);

const PAGE = "layout";
const PLAY_FROM_LABEL = "cw_home";
const INITIAL_MODULE = 0;
const ButtonModalFocus = withFocusable(ModalButtonStyled);
const ListReferenced = props => <List {...props}>{props.children}</List>;
const ListFocus = withFocusable(ListReferenced);
const defaultFocusPath = "lists";
const onlineContent = "online";

const bannerButtonFocusPath = "bannerButton_passThru";

let sdk = null;
let mediaSlider;
// FIXME: WBIGS-690 - Remove with new carousel
let rtlToFix = 0;
const width = window.innerWidth;
const height = window.innerHeight;
let amountOfDownloadedModules = {};
let isChampionsTrophyPage = false;

function buildAmountOfDownloadedModulesObject() {
  Object.values(sections).forEach(section => {
    section !== "search" && (amountOfDownloadedModules[section] = 0);
  });
}

function getErrorHandlingCallbacks(finalModule, isLayoutExpired = false) {
  const {
    stateActions: { hideGlobalModal },
    history: { goBack }
  } = this.props;
  const retry = () => {
    this.setState({ didPlayerLaunch: false });
    hideGlobalModal();
    this.getLayout(INITIAL_MODULE, finalModule, isLayoutExpired);
  };
  const back = () => {
    this.setState({ didPlayerLaunch: false });
    hideGlobalModal();
    goBack();
  };

  return { retry, back };
}

/**
 * Handles the error received from getLayout request.
 * @param {Error} error - Error thrown.
 * @param finalModule
 */
async function handleError(error, finalModule = this.getFinalModule()) {
  const {
    stateActions: { showGlobalModal },
    resumeNavigation,
    setFocus
  } = this.props;
  const isLayoutExpired = error.error_code === sdk.mediaManager.mediaErrorCodes.LAYOUT_EXPIRED;
  const { retry, back } = getErrorHandlingCallbacks.call(this, finalModule, isLayoutExpired);

  if (isLayoutExpired) {
    this.props.applicationState.userRelatedModules = null;
    this.getLayout(INITIAL_MODULE, finalModule, isLayoutExpired);
  } else if (!this.state.modules || this.state.modules.modules.length === 0) {
    // Only show errors if there are no modules on screen, otherwise, ignore
    // TODO There are cases when the timeout error message appears like "Gateway Time-out". It should enter in the if
    // Example: When a call to a layout section returns a 503
    if (getAppState().isOnline && error && error.message.indexOf("timeout") > -1) {
      showGlobalModal(
        getInternetConnectivityModalConfig.call(this, {
          retryImplementation: retry,
          backImplementation: back,
          needsDismissableProp: false,
          isTimeout: true
        })
      );
    } else if (!getAppState().isOnline && !error.status && !error.response) {
      showGlobalModal(
        getInternetConnectivityModalConfig.call(this, {
          retryImplementation: retry,
          backImplementation: back
        })
      );
    } else {
      const buttons = [
        {
          ...getGlobalButtonInfo("retry"),
          buttonHandler: retry
        },
        {
          ...getGlobalButtonInfo("back"),
          buttonHandler: back
        }
      ];
      showGlobalModal({
        modalText: i18n.get("global.errors.genericError"),
        buttons
      });
    }
    resumeNavigation();
    setFocus(getGlobalButtonFocusPath("retry"));
  }
}

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modules: null,
      nameSection: getPath(this.props),
      modal4K: false,
      isExiting: false,
      scrollToIndex: -1,
      initialScroll: 0,
      didPlayerLaunch: false,
      isLastRowHeightCache: false,
      mediaControlMenu: getMediaItems(),
      hasHeroModule: false,
      isLoaded: true,
      modulesActualLength: 0,
      isActiveBrand: false,
      priceObj: null
    };

    const isBrand = window.location.pathname.includes("brands");
    this.sections = [];
    this.videoConfig = {};
    this.has4K = false;
    this.initialFocus = defaultFocusPath;
    this.play4KModalFocusPath = null;
    this.confirmModalFocusPath = null;
    this.playFromLabel = PLAY_FROM_LABEL;
    this.onChangeItem = this.onChangeItem.bind(this);
    this.close4KModal = this.close4KModal.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.rowRenderer = this.rowRenderer.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.handleMediaControlsEnter = this.handleMediaControlsEnter.bind(this);
    this.isRowFocused = this.isRowFocused.bind(this);
    this.isCropped = this.isCropped.bind(this);
    this._onModulesUp = this._onModulesUp.bind(this);
    this._onModulesDown = this._onModulesDown.bind(this);
    this._onModulesLeft = this._onModulesLeft.bind(this);
    this._onModulesRight = this._onModulesRight.bind(this);
    this.rowHeightCalculator = this.rowHeightCalculator.bind(this);
    this.dontShowEmptyActive = this.dontShowEmptyActive.bind(this);
    this.getListRowCount = this.getListRowCount.bind(this);
    this.updateCarouselStateIndexes = this.updateCarouselStateIndexes.bind(this);
    this.getInitialSlide = this.getInitialSlide.bind(this);
    this.getLayout = this.getLayout.bind(this);
    this.onBack = this.onBack.bind(this);
    this.onEnterPlay = this.onEnterPlay.bind(this);
    this.onRefCarousel = this.onRefCarousel.bind(this);
    this.onMediaControlsLeft = this.onMediaControlsLeft.bind(this);
    this.onMediaControlsRight = this.onMediaControlsRight.bind(this);
    this.showAnimations = config.get().ui.animations;
    this.throttleTime = config.get().ui.throttle;
    const backToTopConfig = config.get().featureToggles.backToTop;
    this.carouselToShowBack = backToTopConfig && backToTopConfig.carouselToShowBack;
    this.scrollPositions = [];
    this.onModulesUp = throttle(this._onModulesUp, this.throttleTime.medium);
    this.onModulesDown = throttle(this._onModulesDown, this.throttleTime.medium);
    this.onModulesLeft = throttle(this._onModulesLeft, this.throttleTime.medium);
    this.onModulesRight = throttle(this._onModulesRight, this.throttleTime.medium);
    this.isSports = window.location.pathname.includes("sports");
    this.onMediaControlsDown = this.onMediaControlsDown.bind(this);
    this.onMediaControlsUp = this.onMediaControlsUp.bind(this);
    this.handleMediaControlsActions = this.handleMediaControlsActions.bind(this);
    this.closeGlobalModal = this.closeGlobalModal.bind(this);
    this.brandName = getBrandName(isBrand);
    this.cache = new CellMeasurerCache({
      defaultHeight: height / 3,
      fixedWidth: true,
      keyMapper: (rowIndex, columnIndex) => {
        const data = this.state.modules?.modules[rowIndex];
        if (data) {
          return `${data?.id}`;
        } else {
          return `${rowIndex + columnIndex}`;
        }
      }
    });
    this.videoData = null;

    this.TypedCarouselStyledMemo = memo(
      props => {
        return <TypedCarouselStyled {...props} />;
      },
      (props, newProps) => {
        return (
          props.style.height !== "auto" &&
          props.style.height !== newProps.style.height &&
          props.style.top !== newProps.style.top &&
          props.className === newProps.className
        );
      }
    );
    Object.keys(amountOfDownloadedModules).length === 0 && buildAmountOfDownloadedModulesObject();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // FIXME: Try to remove focus path for preventing the modification of scrollToIndex
    const focus4kModal = ["play4KModal_passThru", "playHDModal_passThru"];
    if (
      nextProps.applicationState.currentFocus !== defaultFocusPath &&
      !focus4kModal.includes(nextProps.applicationState.currentFocus)
    ) {
      if (prevState.isExiting) {
        return null;
      } else if (nextProps.applicationState.currentFocus === "buttonPlay") {
        return {
          scrollToIndex: nextProps.applicationState.focusedCarouselIndex || 0
        };
      } else {
        return {
          scrollToIndex: -1
        };
      }
    } else if (prevState.scrollToIndex === -1) {
      // FIXME: WBIGS-690 - Remove with new carousel
      if (
        i18n.getDirection() === directions.RIGHT_TO_LEFT &&
        rtlToFix === 2 &&
        nextProps.applicationState.focusedCarouselIndex &&
        nextProps.applicationState.focusedCarouselItemIndex
      ) {
        rtlToFix = 1;
        nextProps.applicationState.focusedCarouselItemIndex -= 1;
      }

      return {
        scrollToIndex: nextProps.applicationState.focusedCarouselIndex || 0,
        initialScroll: nextProps.applicationState.layoutScrollTop
      };
    } else {
      return null;
    }
  }

  // FIXME: This function doesn't scale so well. What will happen when we have 15 possible popups and 10 different scenarios?
  onBack() {
    const {
      history: { location }
    } = this.props;
    const globalModal = getAppState().globalModal;
    if (globalModal && globalModal.dismissable && !getAppState().isOnline) {
      this.props.stateActions.hideGlobalModal();
      getSdk().systemManager.application.exit();
    } else if (this.state.modal4K) {
      // Close 4K prompt.
      this.close4KModal();
    } else if (this.state.isExiting) {
      // Close exit popup
      this.closeConfirmModal();
    } else if (this.state.didPlayerLaunch) {
      // Cancel player launch
      this.setState({ didPlayerLaunch: false });
      this.props.resumeNavigation();
    } else if (
      (!globalModal || globalModal.dismissable) &&
      this.isEnabled() &&
      this.props.applicationState.currentFocus === "mainMenu" &&
      config.get().featureToggles.exitAppPopup
    ) {
      // Show exit popup
      this.setState({ isExiting: true });
    } else if (this.state.scrollToIndex > this.carouselToShowBack) {
      // Going top if reached carouselToShowBack config
      this.setState({ scrollToIndex: 0 }, this.updateCarouselStateIndexes);
      return true;
    } else if (location.pathname.includes("brands") && this.state.scrollToIndex <= this.carouselToShowBack) {
      this.props.history.replace("/brands");
      // if(this.props.history.action === "REPLACE")
      //   this.props.history.goBack();
    } else if (!location.pathname.includes("explore") && location.pathname.includes("brands")) {
      this.props.history.replace("/brands");
    } else if (!location.pathname.includes("brands") && this.state.scrollToIndex <= this.carouselToShowBack) {
      // this.setState({ scrollToIndex: 0 }, this.updateCarouselStateIndexes);
      this.setState({ scrollToIndex: 0 });
      this.props.setFocus(headerFocusPath);
      mediaSlider && mediaSlider.down();
      return true;
    }
    this.props.stateActions.setMediaControlItemFocus(-1);
    return true;
  }

  isEnabled = () => !!this.state.modules && !this.state.didPlayerLaunch;

  closeGlobalModal = () => {
    const {
      location,
      setFocus,
      stateActions: { hideGlobalModal }
    } = this.props;
    hideGlobalModal();
    let { name: from, currentFocus, index } = getSavedFocusInfo();
    removeSavedFocusInfo();
    const isHome =
      (from === "/home" && location.pathname === "/") ||
      (from === "/" && location.pathname === "/home") ||
      (from === "/" && location.pathname === "/")
        ? true
        : false;
    if (from === location.state?.from?.name || from === location.pathname || isHome) {
      if (currentFocus === "mediaControls" && index >= 0) {
        this.props.stateActions.setMediaControlItemFocus(index);
      }
      this.props.setFocus(currentFocus || defaultFocusPath);
      return;
    }
    setFocus(defaultFocusPath);
  };

  closeSignUpModal = () => {
    const {
      setFocus,
      stateActions: { hideGlobalModal }
    } = this.props;
    hideGlobalModal();
    setFocus(bannerButtonFocusPath);
  };

  /**
   * New method to handle Hero action buttons functionalities. Play/Trailer/Info.
   *  */

  async handleMediaControlsActions() {
    const {
      setFocus,
      history,
      applicationState: { userAccountStatus, addons, userLogged, focusedMediaControlItemIndex },
      stateActions: { showGlobalModal, hideGlobalModal }
    } = this.props;

    const module = this.state.modules.modules[0];
    const { type, id: moduleId } = module;
    const videoData = this.sections[0].handleAction();
    const { id, programType, progress, seriesId, addonContent } = videoData;
    const isThisDeviceSupported = userLogged ? await isSupportedDeviceForMobileLite.call(this, addonContent) : true;

    this.videoConfig = {
      id,
      progress,
      seriesId,
      titleId4K: videoData["4kProgramId"],
      moduleId
    };

    saveFocusInfo({
      name: this.props.location.pathname || this.props.from,
      currentFocus: this.props.currentFocus,
      index: focusedMediaControlItemIndex
    });

    const CurrentMediaControlList = this.state.mediaControlMenu;
    const selectedMediaControl =
      CurrentMediaControlList[focusedMediaControlItemIndex] &&
      CurrentMediaControlList[focusedMediaControlItemIndex]?.name;

    switch (selectedMediaControl) {
      case "play": // play button
        if (userLogged) {
          if (!isUserAccountActive(userAccountStatus) && !isAddonContent(addonContent)) {
            return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(videoData));
          }
          if (!isUserSubscribedToChannel(addons, addonContent)) {
            return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(videoData));
          }

          if (!isThisDeviceSupported) {
            return showUnSupportedDeviceErrorPopup.call(this, this.closeGlobalModal);
          }

          if (!!getAppState().isOnline) {
            playHandler.call(this, undefined, {
              from: {
                name: this.props.location.pathname || this.props.from,
                currentFocus: this.props.currentFocus,
                index: focusedMediaControlItemIndex
              }
            });
          } else {
            const retry = () => {
              this.setState({ didPlayerLaunch: false });
              hideGlobalModal();
              this.getLayout();
            };

            const back = () => {
              this.setState({ didPlayerLaunch: false });
              hideGlobalModal();
              history.goBack();
            };
            showGlobalModal(
              getInternetConnectivityModalConfig.call(this, {
                retryImplementation: retry,
                backImplementation: back
              })
            );
            setFocus(getGlobalButtonFocusPath("retry"));
          }
        } else {
          showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeGlobalModal);
        }
        break;

      case "trailer": // trailer
        const trailerData = {
          videoType: "trailer",
          id: id,
          moduleId: moduleId,
          moduleType: type,
          from: {
            name: this.props.location.pathname || this.props.from,
            currentFocus: this.props.currentFocus,
            index: focusedMediaControlItemIndex
          }
        };
        const pathname = routes.player;
        history["push"]({
          pathname,
          ...(trailerData && {
            state: trailerData
          })
        });

        break;

      default:
        // info button
        goToDetailPageByProgramType.call(this, {
          id,
          programType,
          moduleId,
          sectionName: this.state.nameSection,
          from: {
            name: this.props.location.pathname || this.props.from,
            currentFocus: this.props.currentFocus,
            index: focusedMediaControlItemIndex
          }
        });
    }
  }

  async handleMediaControlsEnter() {
    if (this.state.didPlayerLaunch) {
      return;
    }
    const {
      applicationState: { currentFocus }
    } = this.props;

    if (this.state.scrollToIndex === -1 && currentFocus === mediaControlFocusPath) {
      this.handleMediaControlsActions();
      return;
    }
  }

  getDataToSentBuyAsset(videoData = null) {
    return {
      title: videoData.title,
      addonContent: videoData.addonContent,
      titleId: videoData.id,
      price: null
    };
  }

  async handleEnter() {
    if (this.state.didPlayerLaunch) {
      return;
    }
    const {
      setFocus,
      history,
      applicationState: { userAccountStatus, addons, userLogged, focusedMediaControlItemIndex },
      stateActions: { showGlobalModal, hideGlobalModal }
    } = this.props;

    saveFocusInfo({
      name: this.props.location.pathname || this.props.from,
      currentFocus: this.props.currentFocus,
      index: focusedMediaControlItemIndex
    });

    const index = this.state.scrollToIndex;
    /**
     * below commented check was there for Explore button present in other layout pages except home (movies/tvshows/arabic etc) pages  below the first carousel
     * So there was some logic implemeneted earlier team for focus managment and position to place below firts carousel in grid layout row.
     *  As per the new UI revamp(Android theme) need to plae Explore button end of the page , so prevoius logics has to be scrapped.
     *  */

    /*const moduleIndex = this.state.nameSection !== "home" && this.state.scrollToIndex > 0 ? index - 1 : index;
     if (this.state.nameSection !== "home" && this.state.scrollToIndex === 1)
    */
    const moduleIndex = index;
    if (
      this.state.nameSection !== "home" &&
      this.state.scrollToIndex === amountOfDownloadedModules[this.state.nameSection]
    ) {
      trackEvent("explore catalogue", this.state.nameSection, this.state.nameSection);
      return this.goFullCatalog();
    }
    const module = this.state.modules.modules[moduleIndex];
    const { type, category, id: moduleId, friendlyTitle, layoutOrder } = module;
    const videoData = this.sections[index].handleAction();
    const { id, programType, progress, seriesId, addonContent, license, products } = videoData;
    const isTVOD =
      (videoData.assetTypes &&
        videoData.assetTypes.length > 0 &&
        isTVODContent(videoData.assetTypes) &&
        isTVODPriority(videoData.assetTypesPriority)) ||
      false;

    const contentType = (license && pramsYouborra(isTVOD, license)) || "SVOD";

    this.videoConfig = {
      id,
      progress,
      seriesId,
      titleId4K: videoData["4kProgramId"],
      moduleId, // FIXME this is not actually something related to video, it should not be here
      contentType,
      onlineContent
    };
    trackEvent(
      "browsing|layout_modules",
      `${this.state.nameSection}|${category}`,
      await getLayoutEventLabel(category, layoutOrder, this.sections[index].selectedIndex, friendlyTitle)
    );

    switch (type) {
      case "LiveChannels": // Live carousel
        if (userLogged) {
          if (!isUserAccountActive(userAccountStatus) && !isAddonContent(addonContent)) {
            return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(videoData));
          }
          if (!isUserSubscribedToChannel(addons, addonContent)) {
            return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(videoData));
          }

          this.setState(
            {
              isLoaded: false
            },
            async () => {
              const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, addonContent);
              this.setState({ isLoaded: true });
              if (!isThisDeviceSupported) {
                return showUnSupportedDeviceErrorPopup.call(this, this.closeGlobalModal);
              }

              if (!!getAppState().isOnline) {
                playHandler.call(this, {
                  from: {
                    name: this.props.location.pathname || this.props.from,
                    currentFocus: this.props.currentFocus,
                    index: focusedMediaControlItemIndex
                  }
                });
                this.props.stateActions.setCarouselItemFocus(0);
              } else {
                const retry = () => {
                  this.setState({ didPlayerLaunch: false });
                  hideGlobalModal();
                  this.getLayout();
                };

                const back = () => {
                  this.setState({ didPlayerLaunch: false });
                  hideGlobalModal();
                  history.goBack();
                };
                showGlobalModal(
                  getInternetConnectivityModalConfig.call(this, {
                    retryImplementation: retry,
                    backImplementation: back
                  })
                );
                setFocus(getGlobalButtonFocusPath("retry"));
              }
            }
          );
        } else {
          showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeGlobalModal);
        }
        break;

      case "cw": // continue watching
        this.props.stateActions.setPosterLandscapeImage(
          (videoData && videoData.images && videoData.images.posterLandscape) || ""
        );
        videoData && videoData.license && setCurrentStatusForPlayerObj(videoData && videoData.license);
        let isSVOD = isSVODContent(videoData.assetTypes) || false;
        const isAssetActive = isSVOD ? isContentActive(addons, addonContent) : false;

        let isTVODFlow = false;
        if (isTVOD && !isAssetActive) {
          if (license && (license.state.toLowerCase() === "init" || license.state.toLowerCase() === "active")) {
            isTVODFlow = true;
          } else if (license && expiredContent(license.state) && products) {
            return showExpiredContentModal.call(this, this.closeGlobalModal, videoData);
          } else {
            return showExpiredContentModal.call(this, this.closeGlobalModal, videoData);
          }
        }

        if (isSVOD && !isAssetActive && !isTVODFlow) {
          // FIXME This could be better done without a magic string, but the new carousel refactoring will change all this
          if (!isUserAccountActive(userAccountStatus) && !isAddonContent(addonContent)) {
            return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(videoData));
          }

          if (!isUserSubscribedToChannel(addons, addonContent)) {
            return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(videoData));
          }
        }

        this.setState(
          {
            isLoaded: false
          },
          async () => {
            const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, addonContent);
            this.setState({ isLoaded: true });
            if (!isThisDeviceSupported) {
              return showUnSupportedDeviceErrorPopup.call(this, this.closeGlobalModal);
            }

            if (getAppState().isOnline) {
              playHandler.call(this);
              this.props.stateActions.setCarouselItemFocus(0);
            } else {
              const retry = () => {
                this.setState({ didPlayerLaunch: false });
                hideGlobalModal();
                this.getLayout();
              };

              const back = () => {
                this.setState({ didPlayerLaunch: false });
                hideGlobalModal();
                history.goBack();
              };
              showGlobalModal(
                getInternetConnectivityModalConfig.call(this, {
                  retryImplementation: retry,
                  backImplementation: back
                })
              );
              setFocus(getGlobalButtonFocusPath("retry"));
            }
          }
        );

        break;
      case "channels":
        const itemToRedirect = module.titles[getAppState().focusedCarouselItemIndex];
        this.props.stateActions.setCarouselFocus(0);
        history.push("/brands/" + itemToRedirect?.name);

        break;
      default:
        this.props.stateActions.setPosterLandscapeImage(
          (videoData && videoData.images && videoData.images.posterLandscape) || ""
        );

        goToDetailPageByProgramType.call(this, {
          id,
          programType,
          moduleId,
          sectionName: this.state.nameSection,
          from: {
            name: this.props.location.pathname || this.props.from,
            currentFocus: this.props.currentFocus,
            index: focusedMediaControlItemIndex
          }
        });
    }
  }

  goFullCatalog() {
    const { history } = this.props;
    const fullCatalogPath = `${routes.explore}${history.location.pathname}`;
    history.push({
      pathname: fullCatalogPath,
      state: {
        sectionName: this.state.nameSection,
        from: {
          name: this.props.location.pathname || this.props.from,
          currentFocus: this.props.currentFocus,
          index: -1
        }
      }
    });
  }

  onChangeItem(index) {
    this.props.stateActions.setCarouselItemFocus(index);

    if (this.props.applicationState.focusedCarouselIndex === 0) {
      this.checkTrailerMediaButtonToShow(0, index);
    }
  }

  close4KModal() {
    this.setState({ modal4K: false });
    this.props.setFocus(defaultFocusPath);
  }

  closeConfirmModal() {
    this.setState({ isExiting: false });
    this.props.setFocus(defaultFocusPath);
  }

  updateCarouselStateIndexes() {
    // Clear cached heights if not measured from start
    try {
      if (!this.cache.has(this.state.scrollToIndex) || Object.keys(this.cache._rowHeightCache).length < 3) {
        this.cache.clearAll();
      }
    } catch (e) {
      console.log(e);
    }
    try {
      this.props.stateActions.setCarouselFocus(
        this.state.nameSection === "home"
          ? this.state.scrollToIndex
          : [0, 1].includes(this.state.scrollToIndex)
          ? 0
          : this.state.scrollToIndex
      );
      this.props.stateActions.setCarouselItemFocus(0);
    } catch (e) {
      console.log(e);
    }
  }

  onEnterPlay(is4K = false) {
    // Reset continue watching carousel index
    this.props.stateActions.setCarouselItemFocus(0);
    this.setState({ didPlayerLaunch: true });
    this.props.pauseNavigation();
    play.bind(this, is4K)();
  }

  _onModulesUp() {
    if (!!this.state.modules && this.state.scrollToIndex > 0) {
      this.setState(({ scrollToIndex }) => ({ scrollToIndex: scrollToIndex - 1 }), this.updateCarouselStateIndexes);
    } else if (!!this.state.modules && !this.state.isActiveBrand && this.brandName) {
      this.brandName && this.props.setFocus(bannerButtonFocusPath);
      return;
    } else if (this.state.hasHeroModule) {
      return;
    }
  }

  _onModulesDown() {
    try {
      const modulesPageSize = config.get().layouts.modulesPageSize;
      const moduleLength =
        (this.state.modules && this.state.modules?.modules && this.state.modules.modules.length) || 0;
      if (
        !!this.state.modules &&
        this.state.scrollToIndex <
          amountOfDownloadedModules[this.state.nameSection] - (this.state.nameSection !== "home" ? 0 : 1)
      ) {
        this.setState(({ scrollToIndex }) => ({ scrollToIndex: scrollToIndex + 1 }), this.updateCarouselStateIndexes);
        if (
          amountOfDownloadedModules[this.state.nameSection] - this.state.scrollToIndex <= modulesPageSize &&
          amountOfDownloadedModules[this.state.nameSection] < moduleLength
        ) {
          this.getLayout(
            amountOfDownloadedModules[this.state.nameSection],
            amountOfDownloadedModules[this.state.nameSection] + modulesPageSize
          );
        }
      }
    } catch (e) {}
  }

  _onModulesLeft() {
    if (!!this.state.modules) {
      this.left(this.state.scrollToIndex);
    }
  }

  _onModulesRight() {
    if (!!this.state.modules) {
      this.right(this.state.scrollToIndex);
    }
  }

  onMediaControlsLeft() {
    const isHeaderShown = !noHeader(window.location.pathname);
    if (mediaSlider.state.mediaFocusedIndex > 0) {
      mediaSlider.left();
    } else if (isHeaderShown) {
      this.props.setFocus(headerFocusPath);
      mediaSlider && mediaSlider.down();
    }
  }

  onMediaControlsRight() {
    if (mediaSlider.state.mediaFocusedIndex < mediaSlider.state.mediaItemCount) {
      mediaSlider.right();
    }
  }

  onMediaControlsDown() {
    this.props.setFocus(defaultFocusPath);
    this.props.stateActions.setMediaControlItemFocus(-1);
    mediaSlider && mediaSlider.down();
  }
  onMediaControlsUp() {
    return;
  }

  getInitialSlide(index) {
    const {
      applicationState: { focusedCarouselIndex, focusedCarouselItemIndex }
    } = this.props;
    const fixedIndex = this.state.nameSection === "home" || index === 0 ? index : index + 1;
    const moduleTitleLength =
      (this.state.modules &&
        this.state.modules?.modules &&
        this.state.modules?.modules[0] &&
        this.state.modules?.modules[0]?.titles &&
        this.state.modules?.modules[0]?.titles.length) ||
      0;
    if (
      this.state.modules?.modules[index]?.type.toLowerCase() === "hero" &&
      focusedCarouselItemIndex > moduleTitleLength - 1
    ) {
      return 0;
    }
    return this.state.modules.modules[index].category !== CAROUSEL_TYPES.watchlist &&
      fixedIndex === focusedCarouselIndex
      ? focusedCarouselItemIndex
      : 0;
  }

  onRefCarousel(ref) {
    ref && (this.sections[ref.props.carouselIndex] = ref);
  }

  isRowFocused(index) {
    return this.state.scrollToIndex === index;
  }

  isCropped(index) {
    return (
      (index < this.state.scrollToIndex && this.state.scrollToIndex !== this.getListRowCount() - 1) ||
      index > this.state.scrollToIndex
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { isExiting } = this.state;
    isExiting && !prevState.isExiting && this.confirmModalFocusPath && this.confirmModalFocusPath.props.setFocus();

    // FIXME: WBIGS-690 - Remove with new carousel
    if (
      i18n.getDirection() === directions.RIGHT_TO_LEFT &&
      rtlToFix === 1 &&
      this.sections[this.props.applicationState.focusedCarouselIndex]
    ) {
      rtlToFix = 0;
      this.sections[this.props.applicationState.focusedCarouselIndex] &&
        (!this.props.applicationState.userLogged || this.props.applicationState.focusedCarouselIndex !== 1) &&
        this.sections[this.props.applicationState.focusedCarouselIndex].left();
    }
    this.checkLiveCarouselEndOfTheModules();
    //this.toggleMediaControls();
  }

  checkTrailerMediaButtonToShow(focusedCarouselIndex = 0, focusedCarouselItemIndex = 0) {
    if (this.state.modules) {
      let mediaMenu = null;

      if (focusedCarouselIndex === 0) {
        const module = this.state.modules.modules[0];
        const title = module && module.titles[focusedCarouselItemIndex];
        if (!title?.trailerMedia) {
          mediaMenu = this.state.mediaControlMenu.filter(item => item.name !== "trailer");
        } else {
          mediaMenu = getMediaItems();
        }
        this.setState({ mediaControlMenu: mediaMenu });
      }
    }
  }

  toggleMediaControls() {
    return this.props.currentFocus !== "mainMenu" && this.state.scrollToIndex <= 0
      ? mediaSlider?.show()
      : mediaSlider?.hide();
  }

  checkLiveCarouselEndOfTheModules = () => {
    if (this.state.modules) {
      this.state.modules.modules.map((module, index) => {
        if (this.state.modulesActualLength === index + 1 && module?.category === "ListLiveChannels") {
          if (!this.state.isLastRowHeightCache) {
            this.setState({ isLastRowHeightCache: true });
          }
        }
      });
    }
  };
  clearRowHeightCache = () => {
    if (this.state.modules) {
      const modulesLength = this.state.modules ? this.state.modulesActualLength : 0;
      const moduleLastIndex =
        this.state.nameSection !== "home" && modulesLength > 1 ? modulesLength - 1 : modulesLength;
      if (
        this.state.nameSection !== "home" &&
        this.state.modules.modules[moduleLastIndex]?.category === "ListLiveChannels"
      ) {
        this.cache.clearAll();
      }
    }
  };
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.currentFocus !== this.props.currentFocus ||
      nextState.modules !== this.state.modules ||
      nextState.scrollToIndex !== this.state.scrollToIndex ||
      (this.state.modules &&
        nextState.modules.modules.filter(module => !!module?.titles).length !==
          amountOfDownloadedModules[this.state.nameSection]) ||
      nextState.modal4K !== this.state.modal4K ||
      nextState.isExiting !== this.state.isExiting ||
      nextState.didPlayerLaunch !== this.state.didPlayerLaunch ||
      nextState.mediaControlMenu !== this.state.mediaControlMenu ||
      nextState.isLoaded !== this.state.isLoaded
    );
  }

  componentWillUnmount() {
    this.props.resumeNavigation();
    rtlToFix = 2;
  }

  async componentDidMount() {
    if (!this.state.platform) {
      this.setState({
        platform: await getSdk().systemManager.device.getPlatform()
      });
    }
    isChampionsTrophyPage = isChampionsTrophyFlow()
      ? window?.location?.pathname?.includes(CHAMPIONS_TROPHY) || window?.location?.pathname?.includes(CRICLIFE)
      : false;
    this.setState({ hasHeroModule: false });
    if (["/", "/home"].some(a => a === window?.location?.pathname)) {
      // **** tracking event in only home page ****
      trackEventInitializeData({
        page: "view_landingscreen",
        language: getLocaleFromLocalCache() || "en",
        referring_url: this.props.from
      });
      trackEventPushData({ event: "view_landingscreen" });
    }
    trackPage.call(this, PAGE);
    this.props.onRef(this);
    this.props.resumeNavigation();
    const { history, location } = this.props;
    const subscription = findFromBrands(this.state.nameSection, this.props.applicationState.subscriptions || []);
    const baseSubscription = findFromBrands(this.state.nameSection, subscription?.brands);
    this.setState({
      displayName: baseSubscription?.displayName || subscription?.displayName
    });

    this.setPriceObjForBrands.call(this);

    this.deviceBuilt = await getSdk().systemManager.device.getYear();

    // TODO: I'm not 100% sure, but I would bet removing this await would make the component behave identically
    await this.getLayout();
    this.checkTrailerMediaButtonToShow(0, this.props.applicationState.focusedCarouselItemIndex);

    if (this.brandName === "brands") {
      history.location.referrer !== "/brands" && this.setState({ scrollToIndex: 0 }, this.updateCarouselStateIndexes);
      this.props.setFocus("lists");
    }
    const prevFocusInfo = location.state?.from || getSavedFocusInfo();
    if (location.pathname === prevFocusInfo?.name) {
      let { currentFocus, index } = prevFocusInfo;
      if (currentFocus === "mediaControls" && index >= 0) {
        this.props.stateActions.setMediaControlItemFocus(index);
      }
      this.props.setFocus(currentFocus || "lists");
      return;
    }
    this.props.setFocus("lists");
  }

  setPriceObjForBrands() {
    const { addons = [] } = getAppState();
    const isBrand = window.location.pathname.includes("brands");
    if (isBrand) {
      let subscription = findFromBrands(this.brandName, this.props.applicationState.subscriptions || []);
      let isActiveBrand = addons?.find(
        addon =>
          (addon.name === subscription?.name || addon.name === this.brandName) &&
          addon?.status?.toLowerCase() === "active"
      );
      if (getAppState().userAccountStatus?.toLowerCase() === "active" && !isActiveBrand) {
        const base = getAppState().subscriptions?.filter(data => data?.name === starzplay);
        const baseBrands = base && [...base[0]?.brands];
        isActiveBrand = baseBrands?.find(addon => addon.name === subscription?.name || addon.name === this.brandName);
      }

      const priceObj = !isActiveBrand
        ? isChampionsTrophyPage
          ? getBuyBrandsInfoObjChampionsTrophy(addons, this.brandName)
          : getBuyBrandsInfoObj(addons, this.brandName)
        : null;
      this.setState({
        isActiveBrand: isActiveBrand || false,
        priceObj: priceObj
      });
    }
  }

  getUserRelatedModulesIndexes() {
    let {
      applicationState: { userRelatedModules }
    } = this.props;
    if (
      (!userRelatedModules && this.state.modules) ||
      (userRelatedModules && !userRelatedModules[`${this.state.nameSection}`] && this.state.modules)
    ) {
      const userModulesIndexes = [];
      for (let i = 0; i < this.state.modules.modules.length; i++) {
        this.state.modules.modules[i].isDynamic === true && userModulesIndexes.push(i);
      }
      if (userModulesIndexes.length > 0) {
        if (!userRelatedModules) this.props.applicationState.userRelatedModules = {};
        const finalUserRelatedModules = Object.assign(this.props.applicationState.userRelatedModules, {
          [`${this.state.nameSection}`]: userModulesIndexes
        });
        localStorage.setItem("userRelatedModules", JSON.stringify(finalUserRelatedModules));
        return finalUserRelatedModules;
      }
    }
    return userRelatedModules;
  }

  getFinalModule() {
    const { nameSection } = this.state;

    return amountOfDownloadedModules[nameSection] > 0
      ? amountOfDownloadedModules[nameSection] - 1
      : config.get().layouts.modulesPageSize;
  }
  /**
   * New logic has implemented always show latest data for avoided cahced modules.
   * This will take Avoided Cached Modules from Local storage if reload ,otherwise take it from App state
   */

  async getCacheAvoidedModulesFromLStore() {
    const userRelatedModulesFromStore = JSON.parse(localStorage.getItem("userRelatedModules")) || null;
    if (
      !this.props.applicationState.userRelatedModules &&
      this.state.nameSection === "home" &&
      userRelatedModulesFromStore &&
      userRelatedModulesFromStore[`${this.state.nameSection}`]
    ) {
      if (!this.props.applicationState.userRelatedModules) this.props.applicationState.userRelatedModules = {};
      await Object.assign(
        this.props.applicationState.userRelatedModules,
        userRelatedModulesFromStore[`${this.state.nameSection}`]
      );
    }
  }

  async getLayout(initialModule = INITIAL_MODULE, finalModule = this.getFinalModule(), refreshLayout = false) {
    await this.getCacheAvoidedModulesFromLStore();
    const {
      applicationState: { userRelatedModules },
      stateActions: { showGlobalModal }
    } = this.props;
    sdk = await getSdk();
    if (userRelatedModules === null) {
      finalModule = config.get().layouts.modulesPageSize;
    }

    // TODO: Check if it's possible to create a decorator for this type of async calls (X behaviour for isOnline and another one for !isOnline).
    if (getAppState().isOnline) {
      if (!sameLayoutRequestIsInProgress(initialModule, finalModule)) {
        try {
          setLayoutRequestInProgress(initialModule, finalModule);
          const modules = await sdk.mediaManager.getLayout(
            this.state.nameSection,
            {
              initialModule,
              finalModule,
              ...(!!userRelatedModules &&
                userRelatedModules[`${this.state.nameSection}`] &&
                userRelatedModules[`${this.state.nameSection}`].length && {
                  avoidCacheFor: userRelatedModules[`${this.state.nameSection}`]
                }),
              ...(refreshLayout === true && { refreshLayout }),
              version: 2 // parameter send to web sdk for landscape images
            } || []
          );
          const self = this;
          let filteredArray =
            modules &&
            modules.modules &&
            modules.modules.reduce(function(filtered, module) {
              switch (module.category) {
                case "ListBrandsDisabled":
                  if (module && module.layoutOrder <= finalModule) {
                    module.type = "channels";
                    if (self.isSports === false) module.titles = [...getBrands("IN_ACTIVE", module.category)];
                    else module.titles = [...getSportsAddons("IN_ACTIVE", module.category)];
                    module?.titles?.length !== 0 && filtered.push(module);
                  }
                  break;
                case "ListBrandsActive":
                  if (module && module.layoutOrder <= finalModule) {
                    module.type = "channels";
                    if (self.isSports === false) module.titles = [...getBrands("ACTIVE", module.category)];
                    else module.titles = [...getSportsAddons("ACTIVE", module.category)];
                    module?.titles?.length !== 0 && filtered.push(module);
                  }
                  break;
                case "ListLiveChannels":
                  module.type = "LiveChannels";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                case "List5Items":
                  module.type = "List5Items";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                case "List5Org":
                  module.type = "List5Org";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                default:
                  module?.titles?.length !== 0 && filtered.push(module);
              }

              return filtered;
            }, []);

          modules.modules = [...filteredArray];
          // let moduleToPass = modules.length > 0 && modules.modules.find(
          //   module => module.category === "List5CW" || module.type === "cw" || module.category === "ListRentedItems"
          // );
          let moduleToPass = modules.modules.length > 0 && modules.modules.filter(module => module.category !== "Hero");
          if (moduleToPass) {
            moduleToPass = tvodTimeExpire(moduleToPass);
          }
          unsetLayoutRequestInProgress();
          amountOfDownloadedModules[this.state.nameSection] =
            Array.isArray(modules.modules) &&
            modules.modules.length > 0 &&
            modules.modules.filter(module => !!module.titles)?.length;
          const module = modules?.modules[0];
          if (module && this.state.platform !== "ps4" && this.deviceBuilt >= YEAR_CONST) {
            module.titles = module.titles.map((title = {}) => {
              const { images } = title;
              if (images.heroMainFullscreen?.indexOf("data:") === -1) {
                getCacheGeneratedImage(images.heroMainFullscreen, url => {
                  images.heroMainFullscreen = url;
                });
              }
              if (images.posterLandscape?.indexOf("data:") === -1) {
                getCacheGeneratedImage(images.posterLandscape, url => {
                  images.posterLandscape = url;
                });
              }
              return title;
            });
          }
          modules.modules = modules.modules.filter(
            module => (module.titles && module.titles.length > 0) || module.items > 0
          );
          this.setState({
            modules,
            hasHeroModule: module?.type?.toLowerCase() === "hero",
            modulesActualLength: modules.modules.length
          });
          this.props.applicationState.userRelatedModules = this.getUserRelatedModulesIndexes();
        } catch (error) {
          console.log("==> ~ Layout ~ getLayout ~ error:", error);
          Sentry.captureException(error);
          unsetLayoutRequestInProgress();
          handleError.call(this, error, finalModule);
        }
      }
    } else {
      if (this.state.modules && this.state.modules.modules.length) {
        const { retry, back } = getErrorHandlingCallbacks.call(this);
        showGlobalModal(
          getInternetConnectivityModalConfig.call(this, {
            retryImplementation: retry,
            backImplementation: back,
            needsDismissableProp: false,
            isTimeout: true
          })
        );
      }
    }
  }

  left(moduleIndex) {
    const module = this.sections[moduleIndex];
    if (!module) return;
    const { selectedIndex } = module;
    if (i18n.getDirection() !== directions.RIGHT_TO_LEFT && selectedIndex === 0) {
      const isHeaderShown = !noHeader(window.location.pathname);
      if (!isHeaderShown) return;
      this.props.setFocus(headerFocusPath);
      return;
    }
    module.left();
  }

  dontShowEmptyActive() {
    return !getAppState().userLogged;
  }
  right(moduleIndex) {
    const module = this.sections[moduleIndex];
    if (!module) return;
    const { selectedIndex } = module;
    if (i18n.getDirection() === directions.RIGHT_TO_LEFT && selectedIndex === 0) {
      this.props.setFocus(headerFocusPath);
      return;
    }
    module.right();
  }

  getListRowCount() {
    return amountOfDownloadedModules[this.state.nameSection] + (this.state.nameSection !== "home" ? 1 : 0);
  }

  getBrandUrl() {
    const isBrand = window.location.pathname.includes("brands/");
    if (!isBrand) return "";
    const brandName = getBrandName(true);
    return getBrandLogoUrl(brandName, this.props.applicationState.subscriptions);
  }

  isStarzSubscription() {
    const isBrand = window.location.pathname.includes("brands/");
    if (!isBrand) return true;
    const brandName = getBrandName(true);
    return isStarzPlaySubscription(brandName, this.props.applicationState.subscriptions);
  }

  rowRenderer({ key, index, parent, style }) {
    const heroLayout = () => (
      <this.TypedCarouselStyledMemo
        type="hero"
        items={this.state.modules.modules[0].titles}
        carouselIndex={0}
        onRef={this.onRefCarousel}
        initialSlide={this.getInitialSlide(0)}
        onChangeItem={this.onChangeItem}
        slideMargin={"0.55rem"}
        direction={i18n.getDirection()}
        lang={i18n.getLocale()}
        style={style}
        className={this.isRowFocused(0) ? "focused" : this.isCropped(0) ? "cropped" : "row"}
        brandImageUrl={this.getBrandUrl()}
        isBrand={window.location.pathname.includes("brands/") && true}
        isStarz={this.isStarzSubscription()}
        platform={this.state.platform}
      />
    );

    const fullCatalogLayout = () => (
      <div style={style}>
        <ButtonStyled
          label={i18n
            .get(
              "pages.layout.exploreAll",
              this.state.displayName || i18n.get(`global.sections.${this.state.nameSection}`)
            )
            .toUpperCase()}
          size="small"
          carouselIndex={index}
          className={this.isRowFocused(index) ? "focused" : this.isCropped(index) ? "cropped" : "row"}
        />
      </div>
    );

    const carouselLayout = (module, moduleIndex) => (
      <this.TypedCarouselStyledMemo
        key={module.id}
        // FIXME: Adapt module type mapping to new types coming from new API (either 'Carousel' or 'cw')
        type={
          module.type.toLowerCase() === "cw"
            ? "watchlist"
            : module.type.toLowerCase() === "channels"
            ? "channels"
            : module.type.toLowerCase() === "livechannels"
            ? "LiveChannels"
            : module.type === "List5Items"
            ? "List5Items"
            : module.type === "List5Org"
            ? "List5Org"
            : "layout"
        }
        items={getTitlesFormattedForCarousels.call(this, module.type, module.titles)}
        title={
          module.type.toLowerCase() !== "hero" && this.state.nameSection !== "live" && module.type !== "LiveChannels"
            ? module.title
            : ""
        }
        iconTitle={module.type === "LiveChannels" && module.layoutOrder !== 0 ? "live" : ""}
        carouselIndex={index}
        initialSlide={this.getInitialSlide(moduleIndex)}
        onRef={this.onRefCarousel}
        onChangeItem={this.onChangeItem}
        slideMargin={Theme.components.carousel.slideMargin.layout}
        marginBottom={module.type.toLowerCase() === "cw" && (props => props.theme.spacing.small)}
        direction={i18n.getDirection()}
        style={style}
        slideMarginStartLive={
          this.state.nameSection !== "live" &&
          module.type === "LiveChannels" &&
          resolution.carousel.slideMarginStart.homeLive
        }
        isHomePage={this.props.name?.toLowerCase() === "home" ? true : false}
        className={
          this.isRowFocused(index)
            ? `focused ${
                module.type.toLowerCase() === "channels" && module.category === "ListBrandsActive"
                  ? `channelCarosal`
                  : ``
              }`
            : this.isCropped(index)
            ? `cropped ${
                module.type.toLowerCase() === "channels" && module.category === "ListBrandsActive"
                  ? `channelCarosal`
                  : ``
              }`
            : `row ${
                module.type.toLowerCase() === "channels" && module.category === "ListBrandsActive"
                  ? `channelCarosal`
                  : ``
              }`
        }
      />
    );

    const getLayoutRow = index => {
      /** As per the new UI revamp(Android theme) need to place Explore button end of the page , so prevoius logics has to be scrapped. Prevously placed after the first row in grid layout.
       * if (index === 1 && this.state.nameSection !== "home")
       **/

      const moduleData = this.state.modules?.modules[index];
      if (
        moduleData?.id === this.cache._rowHeightCache[moduleData?.id] &&
        index === amountOfDownloadedModules[this.state.nameSection] &&
        this.state.nameSection !== "home"
      ) {
        return fullCatalogLayout();
      } else {
        /*const moduleIndex = this.state.nameSection !== "home" && index > 1 ? index - 1 : index;*/
        const moduleIndex = index;
        const module = this.state.modules.modules[moduleIndex];
        if (module.type.toLowerCase() === "hero") {
          return heroLayout();
        } else {
          return carouselLayout(module, moduleIndex);
        }
      }
    };

    return (
      this.isEnabled() && (
        <CellMeasurer cache={this.cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
          {getLayoutRow(index)}
        </CellMeasurer>
      )
    );
  }

  getScrollTop(index, height) {
    // FIXME: memoization.
    if (!height || this.cache._cellHeightCache[0] === undefined) {
      return undefined;
    } else if (this.scrollPositions[index]) {
      return this.scrollPositions[index];
    }
    const stopY =
      index > 0
        ? new Array(index)
            .fill(undefined)
            .reduce(
              (prev, current, currentIndex) =>
                prev + this.cache._cellHeightCache[this.cache._keyMapper(currentIndex)] || 0,
              0
            )
        : 0;

    const scrollTop = Math.max(
      stopY - height / 2 + (this.cache._cellHeightCache[this.cache._keyMapper(index)] / 2 || 0),
      0
    );

    this.scrollPositions[index] = scrollTop;
    this.props.stateActions.setLayoutScrollTop(scrollTop);
    return scrollTop;
  }

  isScrollEnd() {
    const modulesLength = this.state.modules ? this.state.modulesActualLength : 0;
    if (this.state.nameSection !== "home") {
      return this.state.scrollToIndex === modulesLength;
    }
    return this.state.scrollToIndex + 1 === modulesLength;
  }

  rowHeightCalculator({ index }) {
    const currentModule = this.state.modules?.modules[index];
    if (currentModule?.type === "LiveChannels") {
      return resolution.live.liveChannelCarouselHeight;
    }
    return this.cache._rowHeightCache[currentModule?.id]
      ? this.cache._rowHeightCache[currentModule?.id]
      : this.cache.rowHeight(index);
  }

  redirectToBuyBrandsFromBanner() {
    const {
      applicationState: { userLogged }
    } = this.props;
    const { priceObj } = this.state;

    if (userLogged) {
      redirectTo.call(this, routes.buyBrands, {
        data: {
          addonContent: this.brandName,
          isChampionsTrophyAddOn: isChampionsTrophyPage,
          isCTStandalone: priceObj?.CTAddOnData?.isCTStandalone
        }
      });
    } else {
      showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeSignUpModal);
    }
  }

  render() {
    const { scrollToIndex, modulesActualLength, isActiveBrand, priceObj } = this.state;
    const { location } = this.props;
    const isLoadedEnabled = this.isEnabled();
    const lastModule = this.isScrollEnd() ? ` isLayoutEnd` : ``;
    this.state.isLastRowHeightCache && this.clearRowHeightCache();

    // FIXME: Calculate direction to round floor/ceil.

    return (
      <>
        {this.state.isLoaded && isLoadedEnabled ? (
          <>
            <LayoutStyled
              className={
                this.state.isLoaded &&
                isLoadedEnabled &&
                `hasContent${scrollToIndex > 0 ? ` isLayoutScrolling${lastModule}` : ``} ${!this.state.hasHeroModule &&
                  "noHero"}`
              }
              position={
                !this.state.hasHeroModule
                  ? resolution.layout.positionHeaderHidden
                  : resolution.layout.positionHeaderVisible
              }
              isActive={isActiveBrand}
              isHeroAndBanner={noHeader && !isActiveBrand && this.brandName && priceObj && !this.state.hasHeroModule}
            >
              <>
                {modulesActualLength > 0 ? (
                  <>
                    {this.state.hasHeroModule && this.state.mediaControlMenu && (
                      <MediaControlsListFocus
                        focusPath={"mediaControls"}
                        initialSlideIndex={location.state?.from?.index}
                        onRef={ref => (mediaSlider = ref)}
                        onLeft={
                          i18n.getDirection() === directions.RIGHT_TO_LEFT
                            ? this.onMediaControlsRight
                            : this.onMediaControlsLeft
                        }
                        onRight={
                          i18n.getDirection() === directions.RIGHT_TO_LEFT
                            ? this.onMediaControlsLeft
                            : this.onMediaControlsRight
                        }
                        onDown={this.onMediaControlsDown}
                        onUp={this.onMediaControlsUp}
                        onEnterPress={this.handleMediaControlsEnter}
                        mediaControlMenu={this.state.mediaControlMenu}
                      />
                    )}
                    {noHeader && !isActiveBrand && this.brandName && priceObj && (
                      <HeroBanner isActive={!isActiveBrand} className={`${!this.state.hasHeroModule && "noHero"}`}>
                        <ContainerStyled
                          ctaTextLength={
                            (priceObj.subscriptionDisplayName && priceObj.subscriptionDisplayName.length) || 0
                          }
                          flexTextRTL={true}
                        >
                          <ImageBannerStyled src={priceObj.logoImage} alt={this.brandName} />
                          <TextStyled
                            rank="3"
                            text={
                              isChampionsTrophyPage
                                ? `${priceObj.descHeaderTranslation} <br /> ${priceObj.pricingOnBannerTranslation}`
                                : `${priceObj.concatenatedString}`
                            }
                            size="small"
                            flexTextRTL={isChampionsTrophyPage ? false : true}
                          />
                        </ContainerStyled>
                        <ContainerButtonStyled ctaTextLength={priceObj.subscriptionDisplayName.length}>
                          <ButtonBannerFocus
                            label={
                              isChampionsTrophyPage
                                ? i18n
                                    .get(
                                      `pages.layout.activationBanner.buttonAction.${priceObj.buttonDisplayName}`,
                                      priceObj.subscriptionDisplayName
                                    )
                                    .toUpperCase()
                                : priceObj?.planDisplayName
                                ? priceObj.planDisplayName
                                : i18n
                                    .get(`pages.brands.${priceObj.buttonDisplayName}`, priceObj.subscriptionDisplayName)
                                    .toUpperCase()
                            }
                            focusPath={bannerButtonFocusPath}
                            onEnterPress={this.redirectToBuyBrandsFromBanner.bind(this)}
                            size="medium"
                            dataSnUp={""}
                            dataSnDown={`@${defaultFocusPath}`}
                            dataSnLeft={""}
                            dataSnRight={""}
                            icon={"open_lock"}
                            buttonType="primary"
                          />
                        </ContainerButtonStyled>
                      </HeroBanner>
                    )}
                    <ListFocus
                      height={!this.state.hasHeroModule ? height - NO_HEADER_MARGIN_TOP_IN_PX : height}
                      width={width}
                      rowHeight={this.cache.rowHeight}
                      // rowHeight={this.rowHeightCalculator}
                      rowRenderer={this.rowRenderer}
                      rowCount={this.getListRowCount()}
                      columnCount={1}
                      deferredMeasurementCache={this.cache}
                      autoContainerWidth
                      scrollToIndex={scrollToIndex}
                      scrollToAlignment={"center"}
                      style={{ overflowY: "hidden", direction: "inherit" }}
                      overscanRowCount={1}
                      scrollingResetTimeInterval={0}
                      focusPath={defaultFocusPath}
                      onDown={this.onModulesDown}
                      onUp={this.onModulesUp}
                      onLeft={this.onModulesLeft}
                      onRight={this.onModulesRight}
                      onEnterPress={this.handleEnter}
                    />
                  </>
                ) : (
                  <LayoutEmptyStyled>
                    <Text text={i18n.get("pages.layout.emptyScreen.paragraph1")} />
                    <Text text={i18n.get("pages.layout.emptyScreen.paragraph2")} />
                    <Text text={i18n.get("pages.layout.emptyScreen.paragraph3")} />
                  </LayoutEmptyStyled>
                )}
              </>
            </LayoutStyled>
            {this.carouselToShowBack && (
              <Toast
                text={i18n.get("pages.layout.backToTop")}
                icon={"remoteBack"}
                size={"small"}
                isVisible={this.state.scrollToIndex > this.carouselToShowBack}
                isIndicator
              />
            )}
            <ShadowLayoutStyled />
          </>
        ) : (
          <Loading overlay opacity="0" />
        )}

        {this.state.modal4K && (
          <ModalSettings headingText={""} mainText={i18n.get("global.4Ksupported")}>
            <ButtonModalFocus
              label={i18n.get("global.play4K")}
              focusPath="play4KModal_passThru"
              onEnterPress={this.onEnterPlay.bind(this, true)}
              size="small"
              onRef={ref => (this.play4KModalFocusPath = ref)}
              buttonType={"primary"}
              displayBlock={true}
              dataSnUp={i18n.directionFlip("", "@playHDModal_passThru")}
              dataSnDown={i18n.directionFlip("@playHDModal_passThru", "")}
              dataSnLeft={i18n.directionFlip("", "@playHDModal_passThru")}
              dataSnRight={i18n.directionFlip("@playHDModal_passThru", "")}
            />
            <ButtonModalFocus
              label={i18n.get("global.playHD")}
              focusPath="playHDModal_passThru"
              onEnterPress={this.onEnterPlay.bind(this, false)}
              size="small"
              buttonType={"primary"}
              displayBlock={true}
              dataSnUp={i18n.directionFlip("@play4KModal_passThru", "")}
              dataSnDown={i18n.directionFlip("", "@play4KModal_passThru")}
              dataSnLeft={i18n.directionFlip("@play4KModal_passThru", "")}
              dataSnRight={i18n.directionFlip("", "@play4KModal_passThru")}
            />
          </ModalSettings>
        )}
        {this.state.isExiting && ( // FIXME: make this work with globalModal logic when possible (and the other places where is appears too.
          <ModalSettings
            headingText={i18n.get("global.modals.exit.title")}
            mainText={i18n.get("global.modals.exit.text")}
          >
            <ButtonModalFocus
              label={i18n.get("global.no").toUpperCase()}
              focusPath="noOkModal_passThru"
              onEnterPress={this.closeConfirmModal}
              size="small"
              spacing="small"
              displayBlock={true}
              onRef={ref => (this.confirmModalFocusPath = ref)}
              dataSnDown={"@okModal_passThru"}
              dataSnUp={""}
              dataSnLeft={""}
              dataSnRight={""}
            />
            <ButtonModalFocus
              label={i18n.get("global.yes").toUpperCase()}
              focusPath="okModal_passThru"
              onEnterPress={getSdk().systemManager.application.exit}
              size="small"
              displayBlock={true}
              dataSnUp={"@noOkModal_passThru"}
              dataSnDown={""}
              dataSnLeft={""}
              dataSnRight={""}
            />
          </ModalSettings>
        )}
      </>
    );
  }
}

const Component = withAppState(
  withSubtheme(props => <Layout currentFocus={props.applicationState.currentFocus} {...props} />)
);

Component.defaultFocusPath = defaultFocusPath;

export default Component;
